import type { BigFraction } from "@aprao/common/src/math/BigFraction.js";
import { FRACTION_ONE } from "@aprao/common/src/math/fraction.js";
import type {
  WithName,
  WithRelativesSet,
} from "@aprao/common/src/shapes/common.js";
import { makeAutoObservable } from "mobx";

import { WithNameDelegate } from "./delegates/WithNameDelegate.js";
import { WithRelativesSetDelegate } from "./delegates/WithRelativesSetDelegate.js";
import type { NominatorProvidersByKey } from "./RelativesSetFacade.js";

export class NamedRelativesSetFacade<K extends string> {
  constructor(
    readonly $model: WithRelativesSet<K> & WithName,
    readonly _providers: NominatorProvidersByKey<K>,
  ) {
    makeAutoObservable(this);
  }

  get relativesSet() {
    return new WithRelativesSetDelegate(this.$model, this._providers);
  }

  get named() {
    return new WithNameDelegate(this.$model);
  }
}

export const namedRelativesSetFacadeWithAbsolute = <K extends string>(
  model: WithRelativesSet<K | "absolute"> & WithName,
  providers: NominatorProvidersByKey<K>,
) =>
  new NamedRelativesSetFacade(model, {
    ...providers,
    absolute: (): BigFraction | null => FRACTION_ONE,
  });
